/** Build the feedback message for a word-popup issue report. */

export type PopupIssueReportContext = {
  selection: string
  contextSnippet?: string
  kind?: string
  unitType?: string
  lemma?: string
  surface?: string
  headline?: string
  translation?: string
  wordFormId?: string
  articleId?: string
  pagePath?: string
}

export function buildPopupIssueReportMessage(
  userNote: string,
  ctx: PopupIssueReportContext,
): string {
  const lines = [
    '[popup-report]',
    `selection: ${ctx.selection}`,
  ]
  if (ctx.surface && ctx.surface !== ctx.selection) {
    lines.push(`surface: ${ctx.surface}`)
  }
  if (ctx.lemma) lines.push(`lemma: ${ctx.lemma}`)
  if (ctx.kind) lines.push(`kind: ${ctx.kind}`)
  if (ctx.unitType) lines.push(`unitType: ${ctx.unitType}`)
  if (ctx.headline) lines.push(`headline: ${ctx.headline}`)
  if (ctx.translation && ctx.translation !== ctx.headline) {
    lines.push(`translation: ${ctx.translation}`)
  }
  if (ctx.wordFormId) lines.push(`wordFormId: ${ctx.wordFormId}`)
  if (ctx.articleId) lines.push(`articleId: ${ctx.articleId}`)
  if (ctx.contextSnippet) {
    const snippet = ctx.contextSnippet.replace(/\s+/g, ' ').trim().slice(0, 160)
    if (snippet) lines.push(`context: ${snippet}`)
  }
  lines.push('---', userNote.trim())
  return lines.join('\n').slice(0, 2000)
}
